import React, { useState } from "react";
import Layout from "../components/layouts/Layout";

const AgriculturePlatformPage = () => {
  const [selectedTab, setSelectedTab] = useState('overview');

  const platformFeatures = [
    {
      id: 1,
      title: "直接マッチング",
      description: "農家と飲食店、個人消費者をオンライン上で直接繋ぎ、中間マージンを削減",
      icon: "🤝",
      benefits: ["中間マージン削減", "適正価格での提供", "生産者と消費者の直接交流"]
    },
    {
      id: 2,
      title: "デジタル支援",
      description: "需要予測、在庫管理、EC機能などのシステム導入による効率化",
      icon: "📱",
      benefits: ["需要予測による最適化", "在庫管理の自動化", "EC機能での販路拡大"]
    },
    {
      id: 3,
      title: "インフルエンサー活用",
      description: "元Jリーガー・食のインフルエンサー「勇人さん」による認知拡大",
      icon: "📢",
      benefits: ["若年層へのリーチ", "農業・食の魅力発信", "SNSでの認知拡大"]
    }
  ];

  const challenges = [
    {
      category: "農家の課題",
      items: ["中間流通の多層化による収益低下", "後継者不足", "ITリテラシーの低さ"]
    },
    {
      category: "消費者のニーズ",
      items: ["新鮮かつ安全な農作物の入手", "低負担での購入", "生産者との直接つながり"]
    },
    {
      category: "地域ブランド",
      items: ["地域特産品の認知拡大", "ブランド価値向上", "地方創生への貢献"]
    }
  ];

  const businessModel = [
    {
      phase: "初期フェーズ",
      period: "1年以内",
      description: "長野県の農家を中心にスモールスタートし、MVP版プラットフォームで実証",
      goals: ["長野県内でのMVP版導入", "勇人さんによるプロモーション運用開始", "基本機能の検証"]
    },
    {
      phase: "中期展開",
      period: "3年以内",
      description: "全国展開を目指し、システム機能の拡充および複数インフルエンサーとの連携",
      goals: ["全国展開の実現", "システム機能拡充", "複数インフルエンサー連携", "マーケティング強化"]
    },
    {
      phase: "長期戦略",
      period: "5年以上",
      description: "インバウンド対応、海外輸出、スマート農業技術の総合プラットフォーム構築",
      goals: ["インバウンド対応", "海外輸出展開", "IoT・AI最適化技術統合", "総合プラットフォーム化"]
    }
  ];

  const akiyaProject = {
    concept: "空き家や空きテナント（自宅の空きスペース）を用いた箱型有機栽培もしくは水耕栽培キット",
    features: [
      "空き家、空きテナントが採れたて野菜を購入できるスーパーに変身",
      "自宅で野菜を育てることができる&子供の食育",
      "量子リザバなどを用いた野菜栽培の効率化とデータ蓄積",
      "画像検知や異常検知の実験環境"
    ],
    results: [
      "空き家と空きテナントの解決",
      "食料自給率の増加",
      "新鮮な野菜の提供",
      "データ蓄積による技術革新"
    ],
    monetization: [
      "キット貸し出しと運用サポートアプリのサブスク料金",
      "通常のスーパーと同様に購入料金or購入手数料",
      "スーパー自体をサブスクにして購入制限（買い占めリスク回避）"
    ]
  };

  return (
    <Layout 
      title="農業プラットフォーム事業" 
      subtitle="地域農業の構造改革と地方創生を目指すデジタル農業支援システム"
    >
      {/*  */}
      <section style={{ 
        padding: '80px 0 80px',
        background: 'linear-gradient(135deg, #16a34a 0%, #15803d 50%, #166534 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '40px', 
                flexWrap: 'wrap',
                marginTop: '40px'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>直接</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>マッチング</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>AI</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>需要予測</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>SNS</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>インフルエンサー</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* タブナビゲーション */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center' }}>
                <div style={{ display: 'inline-flex', background: 'rgba(30, 41, 59, 0.8)', borderRadius: '8px', padding: '4px' }}>
                  <button
                    onClick={() => setSelectedTab('overview')}
                    style={{
                      margin: '4px',
                      padding: '12px 24px',
                      borderRadius: '6px',
                      border: 'none',
                      background: selectedTab === 'overview' ? '#16a34a' : 'transparent',
                      color: selectedTab === 'overview' ? 'white' : '#cbd5e1',
                      cursor: 'pointer',
                      transition: 'all 0.3s'
                    }}
                  >
                    🌾 事業概要
                  </button>
                  <button
                    onClick={() => setSelectedTab('features')}
                    style={{
                      margin: '4px',
                      padding: '12px 24px',
                      borderRadius: '6px',
                      border: 'none',
                      background: selectedTab === 'features' ? '#16a34a' : 'transparent',
                      color: selectedTab === 'features' ? 'white' : '#cbd5e1',
                      cursor: 'pointer',
                      transition: 'all 0.3s'
                    }}
                  >
                    ⚡ 機能・特徴
                  </button>
                  <button
                    onClick={() => setSelectedTab('roadmap')}
                    style={{
                      margin: '4px',
                      padding: '12px 24px',
                      borderRadius: '6px',
                      border: 'none',
                      background: selectedTab === 'roadmap' ? '#16a34a' : 'transparent',
                      color: selectedTab === 'roadmap' ? 'white' : '#cbd5e1',
                      cursor: 'pointer',
                      transition: 'all 0.3s'
                    }}
                  >
                    🗺️ ロードマップ
                  </button>
                  <button
                    onClick={() => setSelectedTab('akiya')}
                    style={{
                      margin: '4px',
                      padding: '12px 24px',
                      borderRadius: '6px',
                      border: 'none',
                      background: selectedTab === 'akiya' ? '#16a34a' : 'transparent',
                      color: selectedTab === 'akiya' ? 'white' : '#cbd5e1',
                      cursor: 'pointer',
                      transition: 'all 0.3s'
                    }}
                  >
                    🏠 空き家活用
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 事業概要 */}
      {selectedTab === 'overview' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div style={{ 
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(22, 163, 74, 0.2)',
                  borderRadius: '12px',
                  padding: '40px',
                  marginBottom: '30px'
                }}>
                  <h3 style={{ color: '#16a34a', marginBottom: '25px' }}>🎯 事業コンセプト</h3>
                  <p style={{ color: '#cbd5e1', lineHeight: '1.8', marginBottom: '30px' }}>
                    農業プラットフォーム事業は、DeepTeLLの技術力とデータ解析手法を活用し、地域農業の構造改革・地方創生を目指します。
                    農家と飲食店、個人消費者をオンライン上で直接繋ぎ、中間マージンを削減しつつ高品質な農作物を適正価格で提供することで、
                    農業従事者の収益改善と消費者の利便性向上を両立させます。
                  </p>

                  <h4 style={{ color: '#f1f5f9', marginBottom: '20px' }}>背景・課題</h4>
                  <div className="row">
                    {challenges.map((challenge, index) => (
                      <div key={index} className="col-md-4" style={{ marginBottom: '20px' }}>
                        <div style={{ 
                          background: 'rgba(220, 38, 38, 0.1)',
                          padding: '20px',
                          borderRadius: '8px'
                        }}>
                          <h6 style={{ color: '#ef4444', marginBottom: '15px' }}>{challenge.category}</h6>
                          <ul style={{ color: '#cbd5e1', fontSize: '14px', paddingLeft: '15px' }}>
                            {challenge.items.map((item, idx) => (
                              <li key={idx} style={{ marginBottom: '5px' }}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div style={{ 
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(22, 163, 74, 0.2)',
                  borderRadius: '12px',
                  padding: '30px'
                }}>
                  <h4 style={{ color: '#16a34a', marginBottom: '20px' }}>🎯 ターゲット地域</h4>
                  <div style={{ marginBottom: '20px' }}>
                    <h6 style={{ color: '#f1f5f9', marginBottom: '10px' }}>初期展開</h6>
                    <p style={{ color: '#cbd5e1', fontSize: '14px' }}>長野県（川上村レタス等の地域特産品）</p>
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <h6 style={{ color: '#f1f5f9', marginBottom: '10px' }}>中期展開</h6>
                    <p style={{ color: '#cbd5e1', fontSize: '14px' }}>全国の農業地域</p>
                  </div>
                  <div>
                    <h6 style={{ color: '#f1f5f9', marginBottom: '10px' }}>長期展開</h6>
                    <p style={{ color: '#cbd5e1', fontSize: '14px' }}>海外輸出・インバウンド対応</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 機能・特徴 */}
      {selectedTab === 'features' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              {platformFeatures.map((feature) => (
                <div key={feature.id} className="col-md-4" style={{ marginBottom: '40px' }}>
                  <div style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(22, 163, 74, 0.2)',
                    borderRadius: '12px',
                    padding: '30px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '64px', marginBottom: '20px' }}>{feature.icon}</div>
                    <h4 style={{ color: '#16a34a', marginBottom: '15px' }}>{feature.title}</h4>
                    <p style={{ color: '#cbd5e1', marginBottom: '20px', textAlign: 'left' }}>
                      {feature.description}
                    </p>
                    <div>
                      <h6 style={{ color: '#f1f5f9', marginBottom: '10px' }}>主な効果</h6>
                      <ul style={{ color: '#94a3b8', fontSize: '14px', textAlign: 'left', paddingLeft: '15px' }}>
                        {feature.benefits.map((benefit, index) => (
                          <li key={index} style={{ marginBottom: '5px' }}>{benefit}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* システム導入サポート */}
            <div className="row" style={{ marginTop: '60px' }}>
              <div className="col-md-12">
                <div style={{ 
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(22, 163, 74, 0.2)',
                  borderRadius: '12px',
                  padding: '40px'
                }}>
                  <h3 style={{ color: '#16a34a', marginBottom: '30px', textAlign: 'center' }}>
                    🛠️ システム導入サポート
                  </h3>
                  <div className="row">
                    <div className="col-md-6">
                      <h5 style={{ color: '#f1f5f9', marginBottom: '15px' }}>デジタル化支援</h5>
                      <ul style={{ color: '#cbd5e1', paddingLeft: '20px' }}>
                        <li style={{ marginBottom: '8px' }}>地方の学生インターンによる農家のデジタル化支援</li>
                        <li style={{ marginBottom: '8px' }}>受注管理・在庫管理のサポート</li>
                        <li style={{ marginBottom: '8px' }}>AIおよび時系列予測による需要予測</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <h5 style={{ color: '#f1f5f9', marginBottom: '15px' }}>将来的展開</h5>
                      <ul style={{ color: '#cbd5e1', paddingLeft: '20px' }}>
                        <li style={{ marginBottom: '8px' }}>家庭用有機栽培キットの開発</li>
                        <li style={{ marginBottom: '8px' }}>IoT・スマート農業技術導入</li>
                        <li style={{ marginBottom: '8px' }}>収穫量や品質の自動管理</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ロードマップ */}
      {selectedTab === 'roadmap' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 style={{ color: '#16a34a', textAlign: 'center', marginBottom: '50px' }}>
                  事業展開ロードマップ
                </h2>
                
                {businessModel.map((phase, index) => (
                  <div key={index} style={{ marginBottom: '40px', position: 'relative' }}>
                    <div style={{ 
                      background: 'rgba(30, 41, 59, 0.8)',
                      border: '1px solid rgba(22, 163, 74, 0.2)',
                      borderRadius: '12px',
                      padding: '30px'
                    }}>
                      <div className="row">
                        <div className="col-md-3">
                          <div style={{ 
                            background: 'rgba(22, 163, 74, 0.2)',
                            padding: '20px',
                            borderRadius: '8px',
                            textAlign: 'center'
                          }}>
                            <h4 style={{ color: '#16a34a', marginBottom: '10px' }}>{phase.phase}</h4>
                            <p style={{ color: '#94a3b8', margin: 0 }}>{phase.period}</p>
                          </div>
                        </div>
                        <div className="col-md-9">
                          <h5 style={{ color: '#f1f5f9', marginBottom: '15px' }}>概要</h5>
                          <p style={{ color: '#cbd5e1', marginBottom: '20px' }}>{phase.description}</p>
                          
                          <h6 style={{ color: '#f1f5f9', marginBottom: '10px' }}>主要目標</h6>
                          <ul style={{ color: '#94a3b8', paddingLeft: '20px' }}>
                            {phase.goals.map((goal, idx) => (
                              <li key={idx} style={{ marginBottom: '5px' }}>{goal}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    
                    {index < businessModel.length - 1 && (
                      <div style={{ 
                        textAlign: 'center', 
                        margin: '20px 0',
                        color: '#16a34a',
                        fontSize: '24px'
                      }}>
                        ↓
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 空き家活用プロジェクト */}
      {selectedTab === 'akiya' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 style={{ color: '#16a34a', textAlign: 'center', marginBottom: '50px' }}>
                  🏠 空き家活用プロジェクト
                </h2>
                
                <div style={{ 
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(22, 163, 74, 0.2)',
                  borderRadius: '12px',
                  padding: '40px',
                  marginBottom: '40px'
                }}>
                  <h3 style={{ color: '#16a34a', marginBottom: '20px' }}>💡 プロジェクト概要</h3>
                  <p style={{ color: '#cbd5e1', fontSize: '18px', lineHeight: '1.8' }}>
                    {akiyaProject.concept}
                  </p>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div style={{ 
                      background: 'rgba(30, 41, 59, 0.8)',
                      border: '1px solid rgba(22, 163, 74, 0.2)',
                      borderRadius: '12px',
                      padding: '30px',
                      textAlign: 'center'
                    }}>
                      <h4 style={{ color: '#16a34a', marginBottom: '20px' }}>🚀 実現できること</h4>
                      <ul style={{ color: '#cbd5e1', paddingLeft: '15px' }}>
                        {akiyaProject.features.map((feature, index) => (
                          <li key={index} style={{ marginBottom: '10px' }}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div style={{ 
                      background: 'rgba(30, 41, 59, 0.8)',
                      border: '1px solid rgba(22, 163, 74, 0.2)',
                      borderRadius: '12px',
                      padding: '30px',
                      textAlign: 'center'
                    }}>
                      <h4 style={{ color: '#16a34a', marginBottom: '20px' }}>📈 期待される成果</h4>
                      <ul style={{ color: '#cbd5e1', paddingLeft: '15px' }}>
                        {akiyaProject.results.map((result, index) => (
                          <li key={index} style={{ marginBottom: '10px' }}>{result}</li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div style={{ 
                      background: 'rgba(30, 41, 59, 0.8)',
                      border: '1px solid rgba(22, 163, 74, 0.2)',
                      borderRadius: '12px',
                      padding: '30px',
                      textAlign: 'center'
                    }}>
                      <h4 style={{ color: '#16a34a', marginBottom: '20px' }}>💰 マネタイズ</h4>
                      <ul style={{ color: '#cbd5e1', paddingLeft: '15px' }}>
                        {akiyaProject.monetization.map((item, index) => (
                          <li key={index} style={{ marginBottom: '10px' }}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                <div style={{ 
                  background: 'rgba(22, 163, 74, 0.1)',
                  border: '1px solid rgba(22, 163, 74, 0.3)',
                  borderRadius: '12px',
                  padding: '30px',
                  marginTop: '40px',
                  textAlign: 'center'
                }}>
                  <h4 style={{ color: '#16a34a', marginBottom: '15px' }}>💡 副業効果も期待</h4>
                  <p style={{ color: '#cbd5e1' }}>
                    貸し出したキットを空きテナントや空き家に置くことで、副業効果も見込まれます。<br />
                    自分で栽培した野菜を販売できるシステムも構築予定です。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section style={{ 
        padding: '80px 0',
        background: 'linear-gradient(135deg, #16a34a 0%, #15803d 50%, #166534 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px', fontSize: '32px' }}>
                農業プラットフォーム事業への参画
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                地域農業の未来を一緒に創造しませんか？<br />
                農家、飲食店、投資家の皆様からのご相談をお待ちしています
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <a href="/contact/partnership" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                  事業提携を相談
                </a>
                <a href="/contact/demo" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  color: '#16a34a',
                  border: '2px solid white'
                }}>
                  デモを申し込む
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AgriculturePlatformPage; 